import { useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { HOST } from "../lib/content";

const CALENDAR_URL = "https://link.smallbusinessautomator.com/widget/booking/MzzqNaU2oC0CM9X5fdzw";

export default function BookingPage() {
  const lead = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("dfl_lead"));
    } catch {
      return null;
    }
  }, []);

  const src = useMemo(() => {
    const params = new URLSearchParams();
    if (lead?.firstName) params.set("first_name", lead.firstName);
    if (lead?.lastName) params.set("last_name", lead.lastName);
    if (lead?.email) params.set("email", lead.email);
    if (lead?.phone) params.set("phone", lead.phone);
    const q = params.toString();
    return q ? `${CALENDAR_URL}?${q}` : CALENDAR_URL;
  }, [lead]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://link.smallbusinessautomator.com/js/form_embed.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="bg-[#0E2A54] text-[#D9E4F5] min-h-screen grid-bg" data-testid="booking-page">
      <div className="sticky top-0 z-40 border-b border-white/10 bg-[#091E42]/60 backdrop-blur-xl">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" data-testid="booking-back-home-link" className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] text-white/50 hover:text-[#FFFFFF] transition-colors duration-200">
            <ArrowLeft className="w-3.5 h-3.5" /> BACK TO HOME
          </Link>
          <span className="font-mono text-[10px] tracking-[0.25em] text-[#FFFFFF]">STEP 2 OF 2 — PICK YOUR TIME</span>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 pt-14 md:pt-20 pb-24">
        <p className="font-mono text-[11px] tracking-[0.3em] text-[#FFFFFF] mb-5">
          {lead?.firstName ? `NICE WORK, ${lead.firstName.toUpperCase()} —` : "ONE LAST STEP —"} PICK A TIME
        </p>
        <h1 className="font-display uppercase tracking-[-0.03em] leading-[0.95] text-[clamp(30px,4.5vw,52px)] text-[#D9E4F5] mb-4">
          CHOOSE YOUR <span className="text-[#FFFFFF]">CALL SLOT.</span>
        </h1>
        <p className="text-[14px] text-white/50 leading-relaxed max-w-xl mb-10">
          Pick the date and time that works best for your free 1-on-1 Strategy Call with {HOST.name}. You'll get an instant confirmation by email once your slot is booked.
        </p>

        <div className="border border-white/12 bg-white p-1" data-testid="booking-calendar-widget">
          <iframe
            src={src}
            title="Book your Strategy Call"
            id="msgsndr-calendar"
            className="w-full"
            style={{ minHeight: "760px", border: "none", overflow: "hidden" }}
            scrolling="no"
          />
        </div>
        <p className="font-mono text-[10px] text-white/25 mt-4">
          Free · No obligation · Times shown in your local timezone
        </p>
      </div>
    </div>
  );
}
